var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealerPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 49",
    style: {
      enableBackground: "new 0 0 35 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#005996;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.5,
    width: 35,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,0.5c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.6,17.5,30.6S35,27.6,35,18 c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8C22.1,0.9,19.8,0.5,17.5,0.5z M17.5,32.6 c-2.9,0-5.7-0.9-8.2-2.5c-2.4-1.6-4.3-3.9-5.4-6.6c-1.1-2.7-1.4-5.6-0.8-8.5c0.6-2.8,2-5.5,4-7.5c2.1-2.1,4.7-3.5,7.5-4 c2.8-0.6,5.8-0.3,8.5,0.8c2.7,1.1,5,3,6.6,5.4c1.6,2.4,2.5,5.3,2.5,8.2c0,1.9-0.4,3.8-1.1,5.6c-0.7,1.8-1.8,3.4-3.2,4.8 c-1.4,1.4-3,2.4-4.8,3.2C21.3,32.3,19.4,32.6,17.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,16L17,8l-2.4,8H7l6.2,4.4L10.8,28l6.2-4.7l6.2,4.7l-2.4-7.6L27,16H19.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerPin);
export default __webpack_public_path__ + "static/media/dealer-pin.47edc524326663f6cad6365ff8ea75b1.svg";
export { ForwardRef as ReactComponent };